import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';

import {
  BASE_URL,
  ANNOUNCEMENT_CREATE,
  ANNOUNCEMENT_LIST,
  ANNOUNCEMENT_UPDATE,
  ANNOUNCEMENT_DELETE,
  M_POST
} from '@/utils/api';

@Module({ name: 'announcement' })
export default class Announcement extends VuexModule {
  announcementList: Array<Record<string, unknown>> = [];

  @Mutation
  mutateAnnouncement(list: Array<Record<string, unknown>>) {
    this.announcementList = list;
  }

  @Action({ commit: 'mutateAnnouncement', rawError: true })
  async FetchAnnouncement(params: Record<string, unknown> = { type: 'total' }) {
    try {
      const { data } = await axios({
        url: BASE_URL + ANNOUNCEMENT_LIST,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch announcement failed');
      const list = Array.isArray(data?.data) ? data.data : [];
      return list as Array<Record<string, unknown>>;
    } catch (err) {
      throw toError(err, 'Fetch announcement failed');
    }
  }

  @Action({ rawError: true })
  async CreateAnnouncement(params: Record<string, unknown>) {
    try {
      const { data } = await axios({
        url: BASE_URL + ANNOUNCEMENT_CREATE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Create announcement failed');
      return data?.status;
    } catch (err) {
      throw toError(err, 'Create announcement failed');
    }
  }

  @Action({ rawError: true })
  async UpdateAnnouncement(params: Record<string, unknown>) {
    try {
      const { data } = await axios({
        url: BASE_URL + ANNOUNCEMENT_UPDATE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update announcement failed');
      return data?.status;
    } catch (err) {
      throw toError(err, 'Update announcement failed');
    }
  }

  @Action({ rawError: true })
  async DeleteAnnouncement(params: Record<string, unknown>) {
    try {
      const { data } = await axios({
        url: BASE_URL + ANNOUNCEMENT_DELETE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Delete announcement failed');
      return data?.status;
    } catch (err) {
      throw toError(err, 'Delete announcement failed');
    }
  }
}
